import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { NO_CHANGE } from '@adornis/router/client/routing-state-signal.js';
import { routingState } from '@adornis/router/client/routing-state.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import { DateTime } from 'luxon';
import { combineLatest, filter, startWith, switchMap } from 'rxjs';
import { ExamDay } from '../db/examdays.js';

combineLatest([
  currentUser().pipe(filter(user => user !== undefined)),
  currentUser().pipe(
    filter(Boolean),
    switchMap(() => ExamDay.subscribeExamDaysForCurrentUser()({ _id: 1, _class: 1, name: 1, start: 1, end: 1 })),
    startWith([]),
  ),
  routingState.searchParams,
]).subscribe(([user, days, searchParams]) => {
  if (!user || !days.length) return;
  if (searchParams.has('day')) return;
  const mostFittingDay = days
    .filter(day => day.start.startOf('day') >= DateTime.now().startOf('day'))
    .sort((a, b) => a.start.toMillis() - b.start.toMillis())[0];
  if (mostFittingDay && !searchParams.has('day')) {
    searchParams.set('day', mostFittingDay._id);
    goTo({
      path: NO_CHANGE,
      searchParams,
      hash: NO_CHANGE,
      replaceState: true,
    });
    return XSnackbar.show(`Prüfungstag ${mostFittingDay.name} automatisch ausgewählt.`);
  }
});
